module.exports = __webpack_public_path__ + "img/18.c54033bc.jpg";